import { Navigate } from 'react-router-dom'
import { useAuthStore } from 'shared/store/authStore'
import UnifiedLoginForm from '../../components/auth/UnifiedLoginForm'

export default function AdminLogin() {
  const customer = useAuthStore((s) => s.customer)
  if (customer?.token && customer?.user) return <Navigate to="/dashboard" replace />

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" data-testid="page-admin-login">
      <UnifiedLoginForm />
    </div>
  )
}
